/* VYVAE - Force Add to Cart regardless of Shopify availability API (lightweight version) */
(function () {
  'use strict';

  var ATC_TEXT = window.__vyvaATC || 'Add to cart';

  function isVariantsUrl(url) {
    return url.indexOf('/variants') !== -1 || url.indexOf('variants.js') !== -1;
  }

  /* 1. Patch fetch so /variants.js never marks available=false (other requests pass straight through) */
  var _fetch = window.fetch;
  window.fetch = function (resource, init) {
    var promise = _fetch.apply(this, arguments);
    var url = typeof resource === 'string' ? resource : (resource && resource.url) || '';
    if (!isVariantsUrl(url)) return promise;
    return promise.then(function (response) {
      return response.clone().json().then(function (data) {
        if (data && typeof data === 'object') {
          if (Array.isArray(data)) {
            data.forEach(function (v) { v.available = true; });
          } else {
            data.available = true;
          }
        }
        return new Response(JSON.stringify(data), {
          status: response.status,
          statusText: response.statusText,
          headers: response.headers
        });
      }).catch(function () { return response; });
    });
  };

  /* 2. Patch XMLHttpRequest for older theme calls */
  var _XHROpen = XMLHttpRequest.prototype.open;
  var _XHRSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._vyvaUrl = url || '';
    return _XHROpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (this._vyvaUrl && isVariantsUrl(this._vyvaUrl)) {
      this.addEventListener('load', function () {
        try {
          var data = JSON.parse(this.responseText);
          if (Array.isArray(data)) {
            data.forEach(function (v) { v.available = true; });
          } else if (data && typeof data === 'object') {
            data.available = true;
          }
          Object.defineProperty(this, 'responseText', { value: JSON.stringify(data), writable: true });
        } catch (e) {}
      });
    }
    return _XHRSend.apply(this, arguments);
  };

  /* 3. Hide any inline sold out / esgotado banner. Skips script/style/svg nodes (their text can be huge) */
  function removeSoldOutBanners() {
    var all = document.querySelectorAll('body *');
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (el.children && el.children.length > 0) continue;
      var tag = el.tagName.toLowerCase();
      if (tag === 'script' || tag === 'style' || tag === 'noscript' || tag === 'svg' || tag === 'path' || tag === 'img') continue;
      if (el.hasAttribute('data-vyva-removed')) continue;
      var txt = (el.textContent || '').trim().toLowerCase();
      if (!txt || txt.length >= 200) continue;
      if (txt.indexOf('already sold out') !== -1 || txt.indexOf('esgotado') !== -1) {
        var container = el.closest('[class*=banner], [class*=error], [class*=status], [class*=notice], [class*=alert], div, p') || el;
        container.style.display = 'none';
        container.setAttribute('data-vyva-removed', 'true');
      }
    }
  }

  /* 4. Fix button label/disabled state */
  function fixBtn() {
    document.querySelectorAll('.buy-buttons [type=submit]').forEach(function (btn) {
      var txt = (btn.textContent || btn.innerText || '').trim().toLowerCase();
      if (btn.disabled || txt.indexOf('sold') !== -1 || txt.indexOf('esgotado') !== -1 || txt.indexOf('unavailable') !== -1) {
        btn.disabled = false;
        btn.removeAttribute('disabled');
        btn.textContent = ATC_TEXT;
      }
    });
    removeSoldOutBanners();
  }

  /* Debounced: many DOM changes in a row trigger a single pass instead of one full pass each */
  var fixTimer = 0;
  function scheduleFix() {
    if (fixTimer) return;
    fixTimer = setTimeout(function () {
      fixTimer = 0;
      fixBtn();
    }, 120);
  }

  function burst() {
    scheduleFix();
    setTimeout(scheduleFix, 300);
    setTimeout(scheduleFix, 800);
  }

  var observer = new MutationObserver(scheduleFix);

  document.addEventListener('DOMContentLoaded', function () {
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
    fixBtn();
    setTimeout(fixBtn, 800);
    setInterval(fixBtn, 4000);
  });

  document.addEventListener('variant:changed', burst);

  document.addEventListener('change', function (e) {
    if (e.target && (e.target.name || '').indexOf('option') !== -1) burst();
  });

  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && (e.target.closest('[data-option-value]') || e.target.closest('.color-swatch') || e.target.closest('.block-swatch'))) {
      burst();
    }
  });
})();
